import React from "react";

export class Hidden extends React.Component {
    render() {
        return (
            <input
                type="hidden"
                id={this.props.name}
                name={this.props.name}
                autoComplete={this.props.autoComplete}
                min={this.props.min}
                max={this.props.max}
                multiple={this.props.multiple}
                pattern={this.props.pattern}
                placeholder={this.props.placeholder}
                required={this.props.required}
                step={this.props.step}
                onChange={this.props.onChange}
            />
        );
    }
}
